import Link from 'next/link';
import { FC, ReactNode } from 'react';

import { sanitizeUrl } from '@/helpers/storyblokLink';

export interface BlokLinkProps {
  children?: ReactNode;
  full_slug?: any;
  className?: string;
}

const BlokLink: FC<BlokLinkProps> = ({
  full_slug,
  children,
  className = '',
}) => {
  return (
    <Link href={sanitizeUrl(`${full_slug}`)} className={className}>
      <>{children}</>
    </Link>
  );
};

export default BlokLink;
